import { useNavigate, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { AlertTriangle } from 'lucide-react';

interface AssignmentEditBreadcrumbsProps {
  error: string | null;
}

export const AssignmentEditBreadcrumbs = ({
  error,
}: AssignmentEditBreadcrumbsProps) => {
  const navigate = useNavigate();

  return (
    <div className='h-full flex flex-col'>
      <div className='p-6 border-b'>
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to='/assignments'>Assignments</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>Edit</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
      <div className='flex-1 flex items-center justify-center'>
        <Alert variant='destructive' className='max-w-md'>
          <AlertTriangle className='h-4 w-4' />
          <AlertDescription>
            {error || 'Assignment not found'}
            <div className='mt-2'>
              <Button
                variant='outline'
                size='sm'
                onClick={() => navigate('/assignments')}
              >
                Back to Assignments
              </Button>
            </div>
          </AlertDescription>
        </Alert>
      </div>
    </div>
  );
};
